import { ReactComponent as Facebook } from 'assets/icons/icon-facebook.svg';

export default Facebook;
